import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { translate } from 'react-i18next';

import Button from '../../common/Button';
import InputPrimary from '../../common/InputPrimary';
import { required, TextArea } from '../../utils/form';
import * as DateService from '../../utils/date';

import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import 'react-web-tabs/dist/react-web-tabs.css';

const InputLogo = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-tiny"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const InputBackground = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-tiny"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const Input = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-tiny"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const languages = [
  { value: 'en', label: 'English' },
  { value: 'bg', label: 'Български' },
];
const LanguageSelect = (field) => (
  <Select
    isSearchable={false}
    classNamePrefix="c-select"
    className="u-margin-bottom-huge"
    value={languages.find((l) => l.value === field.input.value)}
    onChange={(selectedOption) => field.input.onChange(selectedOption.value)}
    name={field.input.name}
    options={languages}
    {...field}
  />
);

const updatePeriods = [
  { value: 'MONTHLY', label: 'Monthly' },
  { value: 'BI_MONTHLY', label: 'Bi-monthly' },
  { value: 'QUARTERLY', label: 'Quarterly' },
];
const UpdatePeriodSelect = (field) => (
  <Select
    isDisabled={true}
    isSearchable={false}
    classNamePrefix="c-select"
    className="u-margin-bottom-huge"
    value={updatePeriods.find((l) => l.value === field.input.value)}
    onChange={(selectedOption) => field.input.onChange(selectedOption.value)}
    name={field.input.name}
    options={updatePeriods}
    {...field}
  />
);

let Form = ({
  handleSubmit,
  onSubmit,
  submitting,
  error,
  okButtonText,
  t,
  avatarUrl,
  coverUrl,
  slack,
  status,
  defaultPrimaryTab = 'vertical-tab-one',
  userSlots,
  msteams,
}) => (
  <form onSubmit={handleSubmit}>
    <div className="u-margin-vertical u-padding-bottom u-display-flex u-justify-content-between u-align-items-center u-flex-wrap">
      <h3 className="u-margin-vertical-tiny u-color-blue-violet">
        {t('admin.settingsTitle')}
      </h3>
      <Button disbaled={submitting ? 1 : 0} type="submit">
        {submitting ? t('general.sending') : okButtonText}
      </Button>
    </div>
    <Tabs defaultTab={defaultPrimaryTab} vertical>
      <TabList>
        <Tab
          type="button"
          className="c-tabs-vertical"
          tabFor="vertical-tab-one"
        >
          {t('admin.mainSettingsTitle')}
        </Tab>
        <Tab type="button" tabFor="vertical-tab-two">
          {t('admin.settingsScreen.loginScreenTitle')}
        </Tab>
        <Tab type="button" tabFor="vertical-tab-three">
          {t('admin.settingsScreen.onboardingScreenTitle')}
        </Tab>
        <Tab type="button" tabFor="vertical-tab-billing">
          {`${status.isDueDatePassed ? '❗' : ''} ${t(
            'admin.settingsScreen.subscriptionScreenTitle'
          )}`}
        </Tab>
      </TabList>
      <TabPanel tabId="vertical-tab-one">
        <Field
          component={Input}
          name="name"
          label={t('admin.settingsScreen.name')}
          placeholder={t('admin.settingsScreen.namePlaceholder')}
        />
        <div className="u-display-flex u-align-items-center u-justify-content-between">
          <div className="u-flex-1 u-margin-right-large">
            <Field
              component={InputLogo}
              name="avatarUrl"
              label={t('admin.settingsScreen.logo')}
              placeholder={t('admin.settingsScreen.logoPlaceholder')}
            />
          </div>
          <img
            className="o-media__img u-img-round"
            width="115"
            src={avatarUrl}
            alt="Space Logo"
          />
        </div>
        <label className="c-input__label u-padding-bottom-tiny">
          {t('admin.settingsScreen.officialLang')}
        </label>
        <Field name="lang" component={LanguageSelect} />
        <label className="c-input__label u-padding-bottom-tiny">
          {t('admin.settingsScreen.updatePeriod')}
        </label>
        <Field name="updatePeriod" component={UpdatePeriodSelect} />
      </TabPanel>
      <TabPanel tabId="vertical-tab-two">
        <div className="u-display-flex u-align-items-center u-justify-content-between">
          <div className="u-flex-1 u-margin-right-large">
            <Field
              component={InputBackground}
              name="coverUrl"
              label={t('admin.settingsScreen.background')}
              placeholder={t('admin.settingsScreen.backgroundPlaceholder')}
            />
          </div>
          <img
            className="o-media__img u-img-round"
            width="115"
            src={coverUrl}
            alt="Space Background"
          />
        </div>
        <Field
          component={Input}
          name="welcomeMessage"
          label={t('admin.settingsScreen.helloMessage')}
          placeholder={t('admin.settingsScreen.helloMessagePlaceholder')}
        />
        <Field
          component={Input}
          name="slogan"
          label={t('admin.settingsScreen.slogan')}
          placeholder={t('admin.settingsScreen.sloganPlaceholder')}
        />
      </TabPanel>
      <TabPanel tabId="vertical-tab-three">
        <Field
          component={TextArea}
          name="onboardingHtml"
          label={t('admin.settingsScreen.onboardingMessage')}
          validate={[required]}
          rows={11}
          placeholder=""
        />
      </TabPanel>
      <TabPanel tabId="vertical-tab-billing">
        <p>
          <strong>{t('admin.settingsScreen.subscription.planTitle')}</strong>{' '}
          {t(`admin.settingsScreen.subscription.plan.${status.plan}`)}
          <br />
          <strong>
            {t('admin.settingsScreen.subscription.periodTitle')}
          </strong>{' '}
          {DateService.getHumanizedShortDate(status.startsAt)} -{' '}
          {DateService.getHumanizedShortDate(status.endsAt)}
          <br />
          <strong>
            {t('admin.settingsScreen.subscription.slotsTitle')}
          </strong>{' '}
          {userSlots}
          <br />
          <strong>
            {t('admin.settingsScreen.subscription.valueTitle')}
          </strong>{' '}
          {t('admin.settingsScreen.subscription.valueText', { userSlots })}
          <strong>
            {t('admin.settingsScreen.subscription.valueSum', {
              value: userSlots * 4,
            })}
          </strong>
        </p>

        {status.isDueDatePassed && (
          <p className="u-bg-color-cabaret u-color-white u-padding-small">
            {t('admin.settingsScreen.subscription.payNowWarn')}
          </p>
        )}

        <p>
          <strong>
            {t('admin.settingsScreen.subscription.transferTitle')}
          </strong>
          <br />
          {t('admin.settingsScreen.subscription.bank.recepient')}
          <br />
          {t('admin.settingsScreen.subscription.bank.bank')}
          <br />
          <strong>BIC:</strong>{' '}
          {t('admin.settingsScreen.subscription.bank.bic')}
          <br />
          <strong>IBAN:</strong>{' '}
          {t('admin.settingsScreen.subscription.bank.iban')}
        </p>

        <p>
          <strong>
            {t('admin.settingsScreen.subscription.clarification')}
          </strong>
        </p>

        <p>
          <strong>{t('admin.settingsScreen.subscription.contactTitle')}</strong>
          <br />
          {t('admin.settingsScreen.subscription.contact.name')}
          <br />
          <strong>
            {t('admin.settingsScreen.subscription.mobileTitle')}
          </strong>{' '}
          <a
            href={`tel:${t('admin.settingsScreen.subscription.contact.phone')}`}
          >
            {t('admin.settingsScreen.subscription.contact.phone')}
          </a>
          <br />
          <strong>
            {t('admin.settingsScreen.subscription.mailTitle')}
          </strong>{' '}
          <a
            href={`mailto:${t(
              'admin.settingsScreen.subscription.contact.email'
            )}`}
          >
            {t('admin.settingsScreen.subscription.contact.email')}
          </a>
        </p>
      </TabPanel>
    </Tabs>

    <div className="u-padding-top-huge u-padding-bottom-small">
      <hr className="u-border-dashed u-margin-vertical" />
    </div>

    <div className="u-margin-vertical u-padding-bottom u-display-flex u-justify-content-between u-align-items-center u-flex-wrap">
      <h3 className="u-margin-vertical-tiny u-color-blue-violet">
        {t('admin.mailSettingsTitle')}
      </h3>
      <Button disbaled={submitting ? 1 : 0} type="submit">
        {submitting ? t('general.sending') : okButtonText}
      </Button>
    </div>

    <Tabs defaultTab="vertical-tab-four" vertical>
      <TabList>
        <Tab type="button" tabFor="vertical-tab-four">
          {t('admin.settingsScreen.emailInvite.title')}
        </Tab>
        <Tab type="button" tabFor="vertical-tab-five">
          {t('admin.settingsScreen.emailReminders.title')}
        </Tab>
        <Tab type="button" tabFor="vertical-tab-six">
          {t('admin.settingsScreen.emailStats.title')}
        </Tab>
      </TabList>
      <TabPanel tabId="vertical-tab-four">
        <Field
          component={Input}
          name="emails.invite.subject"
          label={t('admin.settingsScreen.emailInvite.subject')}
          placeholder=""
        />
        <Field
          component={TextArea}
          name="emails.invite.html"
          label={t('admin.settingsScreen.emailInvite.message')}
          validate={[required]}
          placeholder=""
          rows={11}
        />
      </TabPanel>
      <TabPanel tabId="vertical-tab-five">
        <p className="u-margin-bottom u-color-blue-violet">
          {t('admin.settingsScreen.emailReminders.descr')}
        </p>
        <Field
          component={Input}
          name="emails.endOfCycleReminder.subject"
          label={t('admin.settingsScreen.emailReminders.subject')}
          placeholder=""
        />
        <Field
          component={TextArea}
          name="emails.endOfCycleReminder.html"
          label={t('admin.settingsScreen.emailReminders.message')}
          validate={[required]}
          placeholder=""
          rows={11}
        />
      </TabPanel>
      <TabPanel tabId="vertical-tab-six">
        <p className="u-margin-bottom u-color-blue-violet">
          {t('admin.settingsScreen.emailStats.descr')}
        </p>
        <Field
          component={Input}
          name="emails.adminStats.subject"
          label={t('admin.settingsScreen.emailStats.subject')}
          placeholder=""
        />
        <Field
          component={TextArea}
          rows={11}
          name="emails.adminStats.html"
          validate={[required]}
          label={t('admin.settingsScreen.emailStats.message')}
          placeholder=""
        />
      </TabPanel>
    </Tabs>

    <div className="u-padding-top-huge u-padding-bottom-small">
      <hr className="u-border-dashed u-margin-vertical" />
    </div>

    <div className="u-margin-vertical u-padding-bottom u-display-flex u-justify-content-between u-align-items-center u-flex-wrap">
      <h3 className="u-margin-vertical-tiny u-color-blue-violet">
        {t('admin.settingsScreen.slack.title')}
      </h3>
      <Button disbaled={submitting ? 1 : 0} type="submit">
        {submitting ? t('general.sending') : okButtonText}
      </Button>
    </div>

    <div className="u-margin-bottom-huge">
      <label className="u-margin-right">
        <Field
          component="input"
          type="radio"
          name="slack.isEnabled"
          value={true}
          className="u-margin-right-micro"
          parse={(val) => val === 'true'}
        />
        {t('admin.settingsScreen.slack.on')}
      </label>
      <label>
        <Field
          component="input"
          type="radio"
          name="slack.isEnabled"
          value={false}
          className="u-margin-right-micro u-margin-bottom"
          parse={(val) => val === 'true'}
        />
        {t('admin.settingsScreen.slack.off')}
      </label>
    </div>
    {slack &&
      slack.isEnabled && (
        <React.Fragment>
          <Tabs
            defaultTab="vertical-tab-seven"
            vertical
            className="u-padding-bottom-huge"
          >
            <TabList>
              <Tab type="button" tabFor="vertical-tab-seven">
                {t('admin.settingsScreen.slack.slackBotSettingsTitle')}
              </Tab>
              <Tab type="button" tabFor="vertical-tab-eight">
                {t('admin.settingsScreen.slack.singleUpdatesTitle')}
              </Tab>
            </TabList>
            <TabPanel tabId="vertical-tab-seven">
              <Field
                component={Input}
                name="slack.webhook"
                label="Slack Incoming WebHook URL"
                placeholder="https://hooks.slack.com/..."
              />
              <Field
                component={Input}
                name="slack.username"
                label="Slack Bot Name"
                placeholder=""
              />
              <Field
                component={Input}
                name="slack.icon_url"
                label="Slack Bot Avatar URL"
                placeholder=""
              />

              <Field
                component={TextArea}
                name="slack.bot.messages.endOfCycleReminder"
                label={t('admin.settingsScreen.slack.reminder')}
                validate={[required]}
                placeholder=""
                rows={11}
              />
              <Field
                component={TextArea}
                name="slack.bot.messages.endOfCycleThanks"
                label={t('admin.settingsScreen.slack.thanks')}
                validate={[required]}
                placeholder=""
                rows={11}
              />
            </TabPanel>
            <TabPanel tabId="vertical-tab-eight">
              <p className="u-margin-bottom u-color-blue-violet">
                {t('admin.settingsScreen.slack.singleUpdatesDescr')}
              </p>
              {slack.bot.updates.map((u, i) => (
                <Field
                  key={u._id}
                  component={TextArea}
                  name={`slack.bot.updates.[${i}].message`}
                  label={t(`admin.settingsScreen.slack.liveUpdates.${u.type}`)}
                  validate={[required]}
                  placeholder=""
                />
              ))}
            </TabPanel>
          </Tabs>
        </React.Fragment>
      )}


    <div className="u-padding-top-huge u-padding-bottom-small">
      <hr className="u-border-dashed u-margin-vertical" />
    </div>

    <div className="u-margin-vertical u-padding-bottom u-display-flex u-justify-content-between u-align-items-center u-flex-wrap">
      <h3 className="u-margin-vertical-tiny u-color-blue-violet">
        {t('admin.settingsScreen.msteams.title')}
      </h3>
      <Button disbaled={submitting ? 1 : 0} type="submit">
        {submitting ? t('general.sending') : okButtonText}
      </Button>
    </div>
    <div className="u-margin-bottom-huge">
      <label className="u-margin-right">
        <Field
          component="input"
          type="radio"
          name="msteams.isEnabled"
          value={true}
          className="u-margin-right-micro"
          parse={(val) => val === 'true'}
        />
        {t('admin.settingsScreen.msteams.on')}
      </label>
      <label>
        <Field
          component="input"
          type="radio"
          name="msteams.isEnabled"
          value={false}
          className="u-margin-right-micro u-margin-bottom"
          parse={(val) => val === 'true'}
        />
        {t('admin.settingsScreen.msteams.off')}
      </label>
    </div>
    {msteams &&
      msteams.isEnabled && (
        <React.Fragment>
          <Tabs
            defaultTab="vertical-tab-seven"
            vertical
            className="u-padding-bottom-huge"
          >
            <TabList>
              <Tab type="button" tabFor="vertical-tab-seven">
                {t('admin.settingsScreen.msteams.settingsTitle')}
              </Tab>
              <Tab type="button" tabFor="vertical-tab-eight">
                {t('admin.settingsScreen.msteams.singleUpdatesTitle')}
              </Tab>
            </TabList>
            <TabPanel tabId="vertical-tab-seven">
              <Field
                component={Input}
                name="msteams.webhook"
                label="Microsoft Teams Incoming WebHook URL"
                placeholder="https://outlook.office.com/webhook/..."
              />
              <Field
                component={TextArea}
                name="msteams.bot.messages.endOfCycleReminder"
                label={t('admin.settingsScreen.msteams.reminder')}
                validate={[required]}
                placeholder=""
                rows={11}
              />
              <Field
                component={TextArea}
                name="msteams.bot.messages.endOfCycleThanks"
                label={t('admin.settingsScreen.msteams.thanks')}
                validate={[required]}
                placeholder=""
                rows={11}
              />
            </TabPanel>
            <TabPanel tabId="vertical-tab-eight">
              <p className="u-margin-bottom u-color-blue-violet">
                {t('admin.settingsScreen.msteams.singleUpdatesDescr')}
              </p>
              {msteams.bot &&
                msteams.bot.updates &&
                msteams.bot.updates.map((u, i) => (
                  <Field
                    key={u._id}
                    component={TextArea}
                    name={`msteams.bot.updates.[${i}].message`}
                    label={t(
                      `admin.settingsScreen.msteams.liveUpdates.${u.type}`
                    )}
                    validate={[required]}
                    placeholder=""
                  />
                ))}
            </TabPanel>
          </Tabs>
        </React.Fragment>
      )}

    {error && <p className="c-alert c-alert--danger u-margin-top">{error}</p>}
  </form>
);

Form = reduxForm({ form: 'admin-workspace-main' })(translate()(Form));

const selector = formValueSelector('admin-workspace-main');
Form = connect((state) => ({
  avatarUrl: selector(state, 'avatarUrl'),
  coverUrl: selector(state, 'coverUrl'),
  slack: selector(state, 'slack'),
  msteams: selector(state, 'msteams'),
}))(Form);

export default Form;



// WEBPACK FOOTER //
// ./src/admin/settings/Form.js